module.exports = __webpack_public_path__ + "img/beijing_door.50b097db.jpg";